import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Contrast } from "../../../types/general.types";
import { LabelSizes, LabelVariants, LabelWeights, } from "../../../Atoms/Text/Label/constants";
import { Label } from "../../../Atoms";
import { Icon } from "../..";
import { IconSizes, IconVariants } from "../../Images/Icon/constants";
import StyledButton from "./Direction.style";
import { DirectionVariants, DirectionWeights, } from "./constants";
const Direction = ({ onClick = () => { }, onMouseOver = () => { }, onMouseLeave = () => { }, isDisabled = false, variant = DirectionVariants.primary, contrast = Contrast.default, weight = DirectionWeights.medium, text = "", }) => {
    const iconName = "itaufonts_seta_right";
    const [onHover, setOnHover] = useState(false);
    const internalOnMouseLeave = () => {
        setOnHover(false);
        onMouseLeave;
    };
    const getLabelProps = (variant, isDisabled, weight, contrast) => {
        const labelProps = {
            weight: LabelWeights.bold,
            size: weight === DirectionWeights.medium
                ? LabelSizes.medium
                : LabelSizes.small,
            isVariant: onHover,
            contrast: contrast,
        };
        if (isDisabled)
            return { labelProps, isDisabled: true, kind: LabelVariants.neutral };
        switch (variant) {
            case DirectionVariants.neutral: {
                return {
                    ...labelProps,
                    variant: LabelVariants.neutral,
                    isDisabled: isDisabled,
                };
            }
            case DirectionVariants.primary: {
                return {
                    ...labelProps,
                    variant: LabelVariants.primary,
                    isDisabled: isDisabled,
                };
            }
            case DirectionVariants.secondary: {
                return {
                    ...labelProps,
                    variant: LabelVariants.secondary,
                    isDisabled: isDisabled,
                };
            }
        }
    };
    const getIconProps = (variant, isDisabled, weight, contrast) => {
        const iconProps = {
            size: IconSizes.small,
            isColorVariant: onHover,
            contrast: contrast,
        };
        switch (variant) {
            case DirectionVariants.neutral: {
                return {
                    ...iconProps,
                    variant: IconVariants.neutral,
                    isDisabled: isDisabled,
                };
            }
            case DirectionVariants.primary: {
                return {
                    ...iconProps,
                    variant: IconVariants.primary,
                    isDisabled: isDisabled,
                };
            }
            case DirectionVariants.secondary: {
                return {
                    ...iconProps,
                    variant: IconVariants.secondary,
                    isDisabled: isDisabled,
                };
            }
        }
    };
    return (_jsxs(StyledButton, { onClick: onClick, onMouseOver: onMouseOver, onMouseEnter: () => setOnHover(true), onMouseLeave: internalOnMouseLeave, isDisabled: isDisabled, variant: variant, contrast: contrast, children: [text && (_jsx(Label, { ...getLabelProps(variant, isDisabled, weight, contrast), children: text })), _jsx(Icon, { name: iconName, ...getIconProps(variant, isDisabled, weight, contrast) })] }));
};
export default Direction;
//# sourceMappingURL=Direction.js.map